export default __webpack_public_path__ + "static/img-schroders-distribution-datathon-b47024a7f65cbe541d594f92dbf988c1.png";